import { observer } from 'mobx-react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { casesFilterOptionsStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFilterOptionsStore'
import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import { CaseFilterIds } from '@new/domains/operations/screens/CasesV2/utils/config'

import * as S from './commonFilterStyles.style'

const _CreatedByFilter = () => {
  const { creatorsByRecordTypes, isLoadingCaseCreators } = casesFilterOptionsStore
  const { createdBy, setFilterValue } = casesFiltersStore

  const handleDataFilter = (value?: string[]) => {
    setFilterValue(CaseFilterIds.CreatedBy, value)
  }

  const filterOptions =
    creatorsByRecordTypes?.map(user => ({
      value: user.id,
      label: user.name,
    })) ?? []

  return (
    <S.CheckBoxWrapper>
      <CheckboxBasedFilter
        title="Created By"
        options={filterOptions}
        isLoadingOptions={isLoadingCaseCreators}
        initialValue={createdBy}
        onChange={handleDataFilter}
      />
    </S.CheckBoxWrapper>
  )
}

export const CreatedByFilter = observer(_CreatedByFilter)
